import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ErrorBoundary } from './components/system/ErrorBoundary';
import { RouteErrorBoundary } from './components/common/RouteErrorBoundary';
import { InvestigationWorkspacePage } from './pages/InvestigationWorkspacePage';
import { EnvironmentGraphPage } from './pages/EnvironmentGraphPage';
import { EnvironmentMonitorPage } from './pages/EnvironmentMonitorPage';
import { TheatreDetailPage } from './pages/TheatreDetailPage';
// Cycle 109 v2 Sprint 1 (S1.7): vessel-surface fixture for AC-1.7.a visual regression baseline.
// Dev-only — visible in prod build too (tiny page, no sensitive data); locked-route in cycle-110+.
import { VesselSurfaceFixturePage } from './pages/VesselSurfaceFixturePage';
// Cycle 109 v2 Sprint 1 (CI-1 review fix): wire /market so NavRail + CmdK navigate to a
// real route. Replaced when the canonical Market surface ships in a later cycle.
import { MarketPlaceholderPage } from './pages/MarketPlaceholderPage';

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      // ── Default → Workspace (intelligence surface) ─────────────────
      {
        path: '/',
        element: <Navigate to="/workspace" replace />,
      },

      // ── Theatre Detail (object inspector) ────────────────────────────
      {
        path: '/theatres/:theatreId',
        element: (
          <ErrorBoundary>
            <TheatreDetailPage />
          </ErrorBoundary>
        ),
      },

      // ── Environment (knowledge graph — Cycle 074) ───────────────────
      {
        path: '/environment',
        element: (
          <ErrorBoundary>
            <EnvironmentGraphPage />
          </ErrorBoundary>
        ),
      },
      {
        path: '/environment/monitor',
        element: (
          <ErrorBoundary>
            <EnvironmentMonitorPage />
          </ErrorBoundary>
        ),
      },
      {
        path: '/theatres/:theatreId/build',
        element: (
          <ErrorBoundary>
            <EnvironmentGraphPage />
          </ErrorBoundary>
        ),
      },
      {
        path: '/theatres/:theatreId/monitor',
        element: (
          <ErrorBoundary>
            <EnvironmentMonitorPage />
          </ErrorBoundary>
        ),
      },

      // ── Workspace (investigation intelligence) ──────────────────────
      {
        path: '/workspace',
        element: (
          <ErrorBoundary>
            <InvestigationWorkspacePage />
          </ErrorBoundary>
        ),
      },

      // ── Market (canonical 3rd page — placeholder until surface ships) ─
      {
        path: '/market',
        element: (
          <ErrorBoundary>
            <MarketPlaceholderPage />
          </ErrorBoundary>
        ),
      },

      // ── Fixtures (S1.7 vessel-surface visual regression) ────────────
      {
        path: '/_fixtures/vessel-surface',
        element: (
          <ErrorBoundary>
            <VesselSurfaceFixturePage />
          </ErrorBoundary>
        ),
      },

      // ── All other routes → Workspace ─────────────────────────────────
      {
        path: '*',
        element: <Navigate to="/workspace" replace />,
      },
    ],
  },
]);
